import { HERO_OUTLINE } from '../../../shared/constants/heroOutline.js'
import { isDisplayable } from '../../../shared/utils/productUtils.js'

import { rawToHeroPreviewItem } from './heroPreviewAdapter.js'

function compareByIdCad(a, b) {
  const aId = String(a?.id_cad ?? '')
  const bId = String(b?.id_cad ?? '')
  return aId.localeCompare(bId, undefined, { numeric: true, sensitivity: 'base' })
}

export function collectActiveFramePathIds(containerEl, currentFrameIndex) {
  if (!containerEl || currentFrameIndex == null) return new Set()

  const frameGroup = containerEl.querySelector(`svg > g[data-frame="${currentFrameIndex}"]`)
  if (!frameGroup) return new Set()

  return new Set(
    Array.from(frameGroup.querySelectorAll('path[id]'))
      .map((path) => path.id)
      .filter(Boolean),
  )
}

export function buildModelPreviewRawItems({
  activeOutline,
  buildings = [],
  tiers = [],
  products = [],
  filteredProducts = [],
}) {
  if (activeOutline === HERO_OUTLINE.BUILDINGS) {
    return buildings.map((building) => ({
      type: HERO_OUTLINE.BUILDINGS,
      building,
    }))
  }

  if (activeOutline === HERO_OUTLINE.TIERS) {
    const buildingById = new Map(buildings.map((building) => [building.id_cad, building]))
    return tiers.map((tier) => ({
      type: HERO_OUTLINE.TIERS,
      tier,
      building: buildingById.get(tier.building_id) ?? null,
    }))
  }

  if (activeOutline === HERO_OUTLINE.APARTMENTS) {
    const visibleUuids = new Set(filteredProducts.map((product) => product.uuid))
    return products
      .filter((product) => isDisplayable(product.visibility))
      .map((product) => ({
        product,
        mode: visibleUuids.has(product.uuid) ? null : null,
      }))
  }

  return []
}

export function buildModelPreviewCandidates({
  containerEl,
  currentFrameIndex,
  activeOutline,
  buildings = [],
  tiers = [],
  products = [],
  filteredProducts = [],
}) {
  const activeFramePathIds = collectActiveFramePathIds(containerEl, currentFrameIndex)
  if (activeFramePathIds.size === 0) return []

  const rawItems = buildModelPreviewRawItems({
    activeOutline,
    buildings,
    tiers,
    products,
    filteredProducts,
  })

  return rawItems
    .map((rawItem) => rawToHeroPreviewItem(rawItem))
    .filter((item) => item && item.svgId && activeFramePathIds.has(item.svgId))
}

export function buildModelProductCandidates({
  containerEl,
  currentFrameIndex,
  products = [],
}) {
  const activeFramePathIds = collectActiveFramePathIds(containerEl, currentFrameIndex)
  if (activeFramePathIds.size === 0) return []

  return products
    .filter((product) => isDisplayable(product.visibility))
    .filter((product) => activeFramePathIds.has(product.uuid))
    .sort(compareByIdCad)
}
